export default __webpack_public_path__ + "static/media/TiemposFine-LightItalic.ed401e8e.woff2";